import { render, staticRenderFns } from "./StallForm.vue?vue&type=template&id=012ccee2"
import script from "./StallForm.vue?vue&type=script&lang=js"
export * from "./StallForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports